export const GOOGLE_MAP_API_KEY = 'AIzaSyAyQpcl8U6rVeuN4nv9nHNIi20kggzxLp8';
export const COOKIES_POLICY_LINK = 'https://app.squadintouch.com/docs/pdf/cookies_policy_v1.0.pdf'
